/*********************
 * AddSearch JS
 *********************/

import BusinessSupportTemplate from "./templates/business-support"
import SupportTemplate from "./templates/support"
import { isAllowedUrl } from './utils'

function initializeAddSearch() {
    let url = window.location.pathname

    // Don't continue if we're not on a valid url that uses search
    if (!isAllowedUrl(url)) {
        return
    }

    // the clients use the same config, except for updateBrowserHistory. We're
    // setting that further below when we configure the page specific. I'm not
    // sure it actually makes a difference since you have to hit enter to search.
    // Also not sure if changing the param below actually changes the behavior
    // since you have to hit enter and it can't be tested.
    let config = {
        searchResultsPageUrl: url,
        analyticsCallback: function (e) {
            gtag('event', 'view_search_results', {
              search_or_click: e.action,
              search_term: e.keyword,
              num_results: e.numberOfResults
            })
        },
        updateBrowserHistory: true,
    }

    const searchClient = AddSearchClient ? new AddSearchClient('32177aa79baf9e3d5850b05aec27a654') : false
    // See the documentation for the AddSearchUI components:
    // https://www.addsearch.com/docs/search-ui/search-ui-library-components/
    const searchUI = AddSearchUI ? new AddSearchUI(searchClient, config) : false

    if (searchUI && searchClient) {
        // Each segment requires dedicated client with appropriate filters etc.
        searchClient.setPaging(1, 10, 'relevance', 'desc')

        searchUI.sortBy({
            containerId: 'sortby-container',
            options: [
                {
                    label: 'Most relevant first',
                    sortBy: 'relevance',
                    order: 'desc',
                },
                {
                    label: 'Date: Newest first',
                    sortBy: 'date',
                    order: 'desc',
                },
                {
                    label: 'Date: Oldest first',
                    sortBy: 'date',
                    order: 'asc',
                }
            ]
        })

        searchUI.pagination({
        containerId: 'pagination-container'
        })

         // configure main search page
         if (url === '/search' && AddSearchClient) {

            // set the client's index
            searchClient.setFilterObject({"category": "0xwww.breezeline.com"})

            // UI components
            searchUI.searchField({
                containerId: 'searchfield-container',
                url: 'Search...',
                // searchAsYouType: true,
            })

            searchUI.searchResults({
                containerId: 'results-container'
            })
        }

        // configure the business support page
        else if (url.includes('/business/support') && searchClient ) {
    
            // Each segment requires dedicated client with appropriate filters etc.
            const blogClient = new AddSearchClient('32177aa79baf9e3d5850b05aec27a654')
            blogClient.setFilterObject({"category": "1xbusiness"})
    
            // UI components
            searchUI.searchField({
                containerId: 'searchfield',
                placeholder: 'Search...',
                button: 'Search',
            })
    
            searchUI.searchResults({
                containerId: 'business-support-results',
                template: BusinessSupportTemplate,
            })    
    
            // segmented search results
            searchUI.segmentedSearchResults({
                containerId: 'business-support-results',
                template: BusinessSupportTemplate,
                client: blogClient,
            })
        }
    
        // configure the main support page
        else if (url.includes('/support') && searchClient ) {
    
            // Each segment requires dedicated client with appropriate filters etc.
            const blogClient = new AddSearchClient('32177aa79baf9e3d5850b05aec27a654')
            blogClient.setFilterObject({"category": "1xsupport"})    
    
            // UI components
            searchUI.searchField({
                containerId: 'searchfield',
                placeholder: 'Search...',
                button: 'Search',
            })
    
            searchUI.searchResults({
                containerId: 'support-results',
                template: SupportTemplate,
            })
    
            // segmented search results
            searchUI.segmentedSearchResults({
                containerId: 'support-results',
                template: SupportTemplate,
                client: blogClient
            })
        }

        // fire it up
        searchUI.start()
    }

    // visibility of the search containers
    let searchInput = document.getElementById('searchfield')?.getElementsByTagName('input')?.item(0)
    let supportContent = document.getElementById('supportContent')
    let supportSearchResults = document.getElementById('supportSearchResults')
    let searchButton = document.querySelector('.addsearch-searchfield-container > form > button')

    function clearSearchResultsURL() {
        const url = new URL(window.location.href)
        url.searchParams.delete('search')
        window.history.replaceState({}, document.title, url.toString())
    }

    function searchVisibility() {
        if (searchInput?.value === '') {
            supportContent?.classList?.remove('hidden')
            supportSearchResults?.classList?.add('hidden')
            supportSearchResults?.classList?.add('pt-8')
            clearSearchResultsURL()
        } else {
            supportContent?.classList.add('hidden')
            supportSearchResults?.classList?.remove('hidden')
            supportSearchResults?.classList?.add('pt-8')
        }
    }

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
            searchVisibility()
        }
    })

    // show search results on button click
    searchButton?.addEventListener('click', function(event) {
        event.preventDefault() // Prevent form submission or page reload
        searchVisibility()
    })

    // check on the input events and show/hide
    let searchInputTimer

    searchInput?.addEventListener('input', function() {
    clearTimeout(searchInputTimer)
        searchInputTimer = setTimeout(() => {
            supportSearchResults?.classList?.add('hidden')
            if (searchInput?.value === '') {
                searchVisibility()
            }
        }, 300) // Adjust the debounce delay as needed (e.g., 300 milliseconds)
    })

    searchVisibility({})
}

window.addEventListener('load', initializeAddSearch)

// Hero Articles - Search Skeleton
document.addEventListener('DOMContentLoaded', () => {
    const heroSkeleton = document.getElementById('searchHeroSkeleton')
    if (heroSkeleton) {
      heroSkeleton.remove()
    }
})
